import { useState, type FormEvent } from "react";
import { api, ApiHatasi, mb } from "../api";
import { Bildirim, Durum, DurumRozeti, HataKutusu, Kart, Tablo, TekSeferlik, useCek } from "../ui";

export function Kutular({ git, rol }: { git: (y: string) => void; rol: "operator" | "musteri" | "kutu" }) {
  const operator = rol === "operator";
  const liste = useCek(() => api.kutular(), []);
  const alanlar = useCek(() => api.alanadlari(), []);
  const [yeni, setYeni] = useState(false);
  const [parola, setParola] = useState<{ adres: string; deger: string } | null>(null);
  const [ara, setAra] = useState("");

  const suzulmus = (liste.veri?.veri ?? []).filter((k) =>
    ara ? k.emailAddress.toLowerCase().includes(ara.toLowerCase()) : true,
  );

  return (
    <>
      <div className="baslik">
        <div>
          <h1>Posta kutuları</h1>
          <p>
            {operator
              ? "Tüm kiracıların kutuları. Kutu açarken paket limiti otomatik uygulanır."
              : "Kurumunuzun posta kutuları. Yeni kutu açarken paket limitiniz otomatik uygulanır."}
          </p>
        </div>
        <div className="eylemler">
          <button className="dugme ana" onClick={() => setYeni((v) => !v)}>
            {yeni ? "Vazgeç" : "Yeni kutu"}
          </button>
        </div>
      </div>

      {parola && (
        <TekSeferlik
          baslik={`${parola.adres} için yeni parola`}
          deger={parola.deger}
          kapat={() => setParola(null)}
        />
      )}

      {yeni && (
        <div style={{ marginBottom: 18 }}>
          <YeniKutu
            alanlar={alanlar.veri?.veri ?? []}
            bitti={(adres, p) => {
              setYeni(false);
              setParola({ adres, deger: p });
              liste.yenile();
            }}
          />
        </div>
      )}

      <Kart
        baslik={`Kutular (${liste.veri?.adet ?? 0})`}
        eylem={
          <input
            className="kucuk-girdi"
            placeholder="ara…"
            value={ara}
            onChange={(e) => setAra(e.target.value)}
            aria-label="Kutu ara"
          />
        }
      >
        <Durum cekim={liste}>
          {() =>
            suzulmus.length === 0 ? (
              <div className="bos">{ara ? "Eşleşen kutu yok" : "Henüz kutu yok"}</div>
            ) : (
              <Tablo basliklar={operator
                  ? ["Adres", "Açıklama", "Kiracı", "#Disk", "Durum", ""]
                  : ["Adres", "Açıklama", "#Disk", "Durum", ""]}>
                {suzulmus.map((k) => (
                  <tr key={k.id}>
                    <td>
                      <strong>{k.emailAddress}</strong>
                    </td>
                    <td style={{ color: "var(--n-600)" }}>{k.description ?? "—"}</td>
                    {operator && <td className="tek">{k.memberTenantId ?? "—"}</td>}
                    <td className="sayi">{mb(k.usedDiskQuota ?? 0)}</td>
                    <td>
                      <DurumRozeti durum={k.panelDurum ?? "aktif"} />
                    </td>
                    <td>
                      <button className="dugme kucuk" onClick={() => git("/kutular/" + k.id)}>
                        aç
                      </button>
                    </td>
                  </tr>
                ))}
              </Tablo>
            )
          }
        </Durum>
      </Kart>
    </>
  );
}

function YeniKutu({
  alanlar,
  bitti,
}: {
  alanlar: { id: string; name: string }[];
  bitti: (adres: string, parola: string) => void;
}) {
  const [ad, setAd] = useState("");
  const [alanAdiId, setAlanAdiId] = useState(alanlar[0]?.id ?? "");
  const [aciklama, setAciklama] = useState("");
  const [hata, setHata] = useState<ApiHatasi | null>(null);
  const [bekliyor, setBekliyor] = useState(false);

  async function gonder(e: FormEvent) {
    e.preventDefault();
    setHata(null);
    setBekliyor(true);
    try {
      const y = await api.kutuAc({ ad: ad.trim(), alanAdiId, aciklama });
      bitti(y.veri.emailAddress, y.parola);
    } catch (h) {
      setHata(h instanceof ApiHatasi ? h : new ApiHatasi(String(h), "bilinmiyor", 0));
    } finally {
      setBekliyor(false);
    }
  }

  const secili = alanlar.find((a) => a.id === alanAdiId);

  return (
    <Kart baslik="Yeni posta kutusu">
      <form className="ic" onSubmit={gonder}>
        {hata && <HataKutusu hata={hata} />}
        <div className="izgara d2">
          <label className="alan">
            <span>Kutu adı *</span>
            <input
              value={ad}
              onChange={(e) => setAd(e.target.value.toLowerCase().replace(/[^a-z0-9._-]/g, ""))}
              required
              autoFocus
              placeholder="info"
            />
            <small>{secili ? `Adres: ${ad || "…"}@${secili.name}` : "Önce alan adı seçin"}</small>
          </label>
          <label className="alan">
            <span>Alan adı *</span>
            <select value={alanAdiId} onChange={(e) => setAlanAdiId(e.target.value)} required>
              {alanlar.map((a) => (
                <option key={a.id} value={a.id}>
                  {a.name}
                </option>
              ))}
            </select>
          </label>
        </div>
        <label className="alan">
          <span>Açıklama</span>
          <input value={aciklama} onChange={(e) => setAciklama(e.target.value)} placeholder="Bilgi İşlem" />
        </label>
        <Bildirim>
          Parola otomatik üretilir ve <strong>yalnızca bir kez</strong> gösterilir. Karışmasın diye
          benzer görünen karakterler (0/O, 1/l) kullanılmaz.
        </Bildirim>
        <button className="dugme ana" disabled={bekliyor || !alanAdiId}>
          {bekliyor ? "Açılıyor…" : "Kutuyu aç"}
        </button>
      </form>
    </Kart>
  );
}
